export enum CinemasDetailsWithAuditoriumsTabs {
  OVERVIEW = 'overview',
  AUDITORIUMS = 'auditoriums',
  ARCHIVE = 'archive',
}
